import type React from 'react';
import { useCallback } from 'react';
import { di } from 'react-magnetic-di';
import { useRouterActions } from 'react-resource-router';
import { useAnalyticsEvents, type AnalyticsEventPayload } from '@atlaskit/analytics-next';
import { UI_EVENT_TYPE } from '@atlassian/analytics-web-react';
import { getEnv } from '@atlassian/help-center-common-util/env';

export const useLinkPush = () => {
	di(useRouterActions, getEnv, useAnalyticsEvents);

	const env = getEnv();
	const { push } = useRouterActions();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const linkPush = useCallback(
		(
			targetUrl: string,
			event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
			analyticsAttributes?: { actionSubjectId: string } & Partial<AnalyticsEventPayload>,
		) => {
			if (analyticsAttributes) {
				createAnalyticsEvent({
					action: 'clicked',
					actionSubject: 'link',
					analyticsType: UI_EVENT_TYPE,
					...analyticsAttributes,
				}).fire();
			}

			if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;

			event.preventDefault();
			push(targetUrl) as void;
		},
		[push, createAnalyticsEvent],
	);

	return {
		push: linkPush,
		baseUrl: env.baseUrl?.replace(/\/+$/, ''),
	};
};
